const defaultFieldValidationMessage = () => {
  return 'Field is required';
}

export const ValidationService = {
  defaultFieldValidationMessage
}
